import React, { useState } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  withStyles
} from '@material-ui/core';
import { SaveButton, FormWithRedirect, ReferenceArrayInput } from 'react-admin';
import GridInput from '../../core/components/inputs/GridInput';
import FundInvestorApi from '../../core/apis/FundInvestorApi';
import GridInputChoices from '../users/userauthorization/GridInputChoices';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import useNotifyServerError from '../../core/hooks/useNotifyServerError';

const styles = () => ({
  dialogContainer: {
    '& .MuiDialog-paper': {
      width: '970px',
      maxWidth: 'unset'
    }
  },
  addButton: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    display: 'flex',
    margin: '10px 8px 0 auto',
    height: '32px'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  },
  title: {
    flex: 1,
    paddingTop: '20px'
  }
});

const AddFundsDialog = props => {
  const { classes, fundInvestors, handleNewFundInv, hasEditPermission } = props;

  const [open, setOpen] = useState(false);
  const notifyServerError = useNotifyServerError();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validateFunds = value => {
    if (Array.isArray(value) && value.length < 1) {
      return 'At least one Fund must be selected';
    }
    return undefined;
  };

  const referenceArrayInputProps = {
    label:
      'To add a Fund, select one or multiple items from the list of the Funds below.',
    optionTextLabel: 'Fund Name',
    optionValueLabel: 'Fund ID',
    resource: 'funds',
    reference: 'funds',
    source: 'funds',
    validate: [validateFunds],
    perPage: -1,
    sort: { field: 'name', order: 'ASC' },
    filter: { onlyFundsWithFundInvestorRelation: 'true' },
    additionalColumns: [
      { label: 'Fund Family', name: 'fundFamilyName' },
      { label: 'Status', name: 'status', isStatusColumn: true }
    ]
  };

  const handleSubmit = async values => {
    let pageData = [];
    const choicesIds = fundInvestors.map(
      choice => `${choice.fundId}:${choice.investorId}`
    );
    try {
      pageData = await FundInvestorApi.getByFundIds(values.funds);
    } catch (e) {
      notifyServerError(e);
    }
    const newData = pageData.filter(data => {
      return !choicesIds.includes(`${data.fundId}:${data.investorId}`);
    });
    handleNewFundInv(newData);
    setOpen(false);
  };

  return (
    <>
      {hasEditPermission && (
        <Button
          color="primary"
          variant="outlined"
          onClick={handleClickOpen}
          className={classes.addButton}
          disableFocusRipple
        >
          Add Fund
        </Button>
      )}
      {open && (
        <FormWithRedirect
          initialValues={{ funds: [], fundId: null }}
          toolbar={null}
          // We override the redux-form name to avoid collision with the react-admin main form
          resource="funds"
          // We override the redux-form onSubmit prop to handle the submission ourselves
          save={handleSubmit}
          className={classes.form}
          variant="standard"
          margin="normal"
          render={({ handleSubmitWithRedirect }) => (
            <Dialog
              open={open}
              onClose={handleClose}
              className={classes.dialogContainer}
            >
              <DialogTitleWithCloseButton onClose={handleClose}>
                Add Fund
              </DialogTitleWithCloseButton>
              <DialogContent>
                <Grid container spacing={1} style={{ width: '100%' }}>
                  <Grid item sm={12}>
                    <ReferenceArrayInput {...referenceArrayInputProps}>
                      <GridInputChoices
                        emptyText={'There are no Funds to be displayed.'}
                      >
                        <GridInput height="500px" />
                      </GridInputChoices>
                    </ReferenceArrayInput>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  label={'Add'}
                  icon={<></>}
                />
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  color="primary"
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
        />
      )}
    </>
  );
};

export default withStyles(styles)(AddFundsDialog);
